module.exports = __webpack_public_path__ + "static/img/logo-slack.9a05c08a.svg";